<template>
    <div>
        <div id="overlayConfetti" @click="off()" style="display: none;">
            <div id="confettiBox" style="display: none; position: fixed;top: 0;right: 0;bottom: 0;left: 0;z-index: 1;">
                <div style="border-radius: 10px;width: 24%;max-height: 10rem;background: #01B1AF;position: absolute;top: 0;
    right: 0;bottom: 0;left: 0;margin: auto;display: flex;align-items: center;justify-content: center;">
                    <div class="text-white" style="text-align: center;">
                        <a class="" @click="off()" style="position: absolute; right: 20px; top: 10px;"><span style="font-size: 23px;">x</span></a>
                        <h4>🎉 Congrats! 🎉</h4>
                        <br>
                        <h5>You are a champion closer! 🎉</h5>
                        <div v-if="Date.now() < new Date(this.user.linkedin_token_expires_date) && this.user.linkedin_service == 1 ">
                            <button type="button" data-toggle="modal" data-target="#projectShareLinkedIn" class="btn btn-block" style="margin-top: 10px; box-shadow: 1px 1px 1px 1px #a0a0a0; padding: 10px 6px;color: #fff; background-color: #0a66c2">
                                <span style=""><b>Share On </b><img src="/images/linkedin-logo-2.png"
                                                                    alt="Share On Your LinkedIn Profile"
                                                                    style="width: 30px; margin-top: -5px;">
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <img :src="confettiPath" height="auto" width="100%" />
        </div>
        <div id="projectShareLinkedIn" class="modal fade" role="dialog">
            <div class="modal-dialog" style="max-width: 870px">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header" style="background-color: #0a66c2; color: #fff">
                        <h5 class="modal-title">Create a post</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form @submit.prevent="shareLinkedin" @keydown="formLinkedin.errors.clear($event.target.name)">
                        <div class="modal-body">
                            <div style="align-items: center; display: flex; margin-bottom: 15px;">
                                <div class="image-placeholder mr-4">
                                    <span role="img" class="profile-photo-preview" :style="previewStyle"></span>
                                </div>
                                <div class="mr-2">
                                    <h6>{{this.user.name}}</h6>
                                </div>
                                <div class="mr-2">
                                    <b-form-select v-model="formLinkedin.visibility" :options="optionsLinkedin" size="sm"></b-form-select>
                                    <div class="text-red text-xs" v-if="formLinkedin.errors.has('visibility')">{{
                                            formLinkedin.errors.get('visibility')
                                        }}
                                    </div>
                                    <input v-model="formLinkedin.project_google_image" type="hidden" name="project_google_image"
                                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                                </div>
                            </div>
                            <div class="mb-2">
                                <b-form-textarea
                                    id="textarea"
                                    v-model="formLinkedin.note"
                                    placeholder="Enter something..."
                                    rows="6"
                                    max-rows="6"
                                ></b-form-textarea>
                                <div class="text-red text-xs" v-if="formLinkedin.errors.has('note')">{{
                                        formLinkedin.errors.get('note')
                                    }}
                                </div>
                            </div>
                            <div style="position: relative">
                                <img v-if="formLinkedin.project_google_image" :src="formLinkedin.project_google_image" style="width: 840px;height: 500px;">
                                <img v-show="formLinkedin.project_google_image" src="http://wecision.com/enterprise/images/icons/closeIcon.png" style="position: absolute; top: 4px; right: 5px" @click.prevent="removeGoogleImage"/>
                                <div class="text-red text-xs" v-if="formLinkedin.errors.has('project_google_image')">{{
                                        formLinkedin.errors.get('project_google_image')
                                    }}
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none" style="background-color: #0a66c2 !important;"
                                :class="{'bg-teal-lighter cursor-not-allowed' : formLinkedin.errors.any(), 'bg-teal' : !formLinkedin.errors.any()}"
                                :disabled="formLinkedin.errors.any() || isActiveShareButton">
                                <span>Share On LinkedIn</span>
                            </button>
                        </div>
                    </form>

                </div>

            </div>
        </div>
        <!-- Modal -->
        <div id="newContactModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">New Contact</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="newContactForm.errors.clear($event.target.name)">
                            <div class="mb-2 flex">
                                <div class="w-4/5">
                                    <label class="text-grey-darkest text-sm" for="new_contact_name"
                                           :class="{'text-red': newContactForm.errors.has('name')}">Name</label>
                                    <input v-model="newContactForm.name" id="new_contact_name" name="name"
                                           maxlength="64"
                                           class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                           :class="{'border-red': newContactForm.errors.has('name')}">
                                    <div class="text-red text-xs" v-if="newContactForm.errors.has('name')">{{
                                            newContactForm.errors.get('name')
                                        }}
                                    </div>
                                </div>
                                <div class="w-1/5 flex justify-center items-center">
<!--                                    <div class="text-center cursor-pointer table mb-0"-->
<!--                                         @click.prevent.stop="openEmailContactModal()">-->
                                    <div class="text-center cursor-pointer table mb-0"
                                         @click.prevent.stop="openNewCompaniesContactModal()">
                                        <i class="fa fa-user fa-2x"></i>
                                        <i class="fa fa-plus-circle text-teal" style="margin-left: -22px"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="email"
                                       :class="{'text-red': newContactForm.errors.has('email')}">Email</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    :class="{'border-red': newContactForm.errors.has('email')}"
                                    type="text" id="email" v-model="newContactForm.email">
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('email')">{{
                                        newContactForm.errors.get('email')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="cell"
                                       :class="{'text-red': newContactForm.errors.has('cell')}">Cell</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    type="text" id="cell" v-model="newContactForm.cell">
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('cell')">{{
                                        newContactForm.errors.get('cell')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="new_contact_title"
                                       :class="{'text-red': newContactForm.errors.has('title')}">Title</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    type="text" id="new_contact_title" v-model="newContactForm.title">
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('title')">{{
                                        newContactForm.errors.get('title')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="new_contact_date"
                                       :class="{'text-red': newContactForm.errors.has('date')}">Follow Up</label>
                                <div class="flex">
                                    <datetime type="datetime" id="new_contact_date" name="date"
                                              v-model="newContactForm.date" use12-hour
                                              class="w-full"
                                              :week-start="7"
                                              :format="masks.date_time_mask"
                                              :use-utc="true"
                                              input-class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                              @input="newContactForm.errors.clear('date')">
                                    </datetime>
                                    <button v-if="newContactForm.date" @click.prevent.stop="removeNewContactDate"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                                    </button>
                                </div>
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('date')">{{
                                        newContactForm.errors.get('date')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2"  v-if="selectedCompany && !selectedCompany.is_residential">
                                <label class="text-sm text-grey-darkest -mb-0"
                                       :class="{'text-red': newContactForm.errors.has('contact_type')}">Contact
                                    Type</label>
                                <multiselect
                                    class="cursor-pointer"
                                    :options="contact_type_options"
                                    v-model="selectedTypeContact"
                                    :show-labels="false"
                                    @input="newContactForm.errors.clear('contact_type')"
                                    track-by="id"
                                    label="code"
                                    value="id">
                                </multiselect>
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('contact_type')">{{
                                        newContactForm.errors.get('contact_type')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0"
                                       :class="{'text-red': newContactForm.errors.has('user')}">User</label>
                                <multiselect
                                    class="cursor-pointer"
                                    :options="usersForContact"
                                    v-model="selectedUserContact"
                                    :show-labels="false"
                                    @input="newContactForm.errors.clear('user')"
                                    track-by="id"
                                    label="name"
                                    value="id">
                                </multiselect>
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('user')">{{
                                        newContactForm.errors.get('user')
                                    }}
                                </div>
                            </div>
                        </form>
                        <company-contact-modal ref="CompaniesContactModal" :masks="this.masks" :symbols="this.symbols"
                                               @selected="parseCompanyContacts"></company-contact-modal>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="newContactSaved"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Add
                        </button>
                        <button
                            class="bg-grey hover:bg-grey-darker px-3 py-1 rounded-full text-white focus:outline-none md:hidden">
                            Cancel
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <form @keydown="form.errors.clear($event.target.name)" @submit.prevent>
            <div class="flex justify-between items-center text-teal hover:text-teal-dark font-base text-sm mb-4">
                <div @click="goBack" class="flex cursor-pointer">
                    <span class="material-icons">chevron_left</span>
                    <span>Back</span>
                </div>
                <button type="button" :disabled="saveButtonDisabled" @click.prevent="saved"
                        class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    <span v-if="savingProject"><i class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>Saving</span>
                    <span v-else>Save</span>
                </button>
            </div>
            <div class="flex justify-between items-start mb-4 flex-wrap flex-lg-nowrap">
                <div class="flex-col w-full lg:w-1/3">
                    <div class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Project Information</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div class="flex items-end">
                                <div class="mb-2 leading-tight mr-2 md:w-3/4">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('name')}" for="name">Project
                                        Name</label>
                                    <input v-model="form.name" type="text" name="name" id="name"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('name')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('name')">{{
                                            form.errors.get('name')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 leading-tight w-1/4 text-right">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('bid_bond')}" for="bid_bond">Bid
                                        Bond</label>
                                    <input type="checkbox" id="bid_bond" name="bid_bond" true-value="1" false-value="0"
                                           v-model="form.bid_bond" :class="{'border-red': form.errors.has('name')}"
                                           @change="resetValidationErrors('bid_bond')">
                                    <div class="text-red text-xs" v-if="form.errors.has('bid_bond')">{{
                                            form.errors.get('bid_bond')
                                        }}
                                    </div>
                                </div>
                            </div>

                            <div class="mb-2 leading-tight">
                                <label class="text-grey-darkest text-sm"
                                       :class="{'text-red' : form.errors.has('address')}" for="address">Address</label>
<!--                              <input v-model="form.address" type="text" name="address"  id="autocomplete" v-on:focus="geolocate()"
                                       class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                       :class="{'border-red': form.errors.has('address')}">
                                <div class="text-red text-xs" v-if="form.errors.has('address')">{{
                                        form.errors.get('address')
                                    }}
                                </div>-->
                                <input id="searchTextField" v-model="form.address" type="text" size="50" name="address"
                                       :class="{'border-red' : form.errors.has('address')}" class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                                <div class="text-red text-xs" v-if="form.errors.has('address')">{{
                                        form.errors.get('address')
                                    }}
                                </div>
                                <input v-model="form.lat" type="hidden" name="lat"
                                       class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                                <input v-model="form.lng" type="hidden" name="lng"
                                       class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                                <input v-model="form.project_google_image" type="hidden" name="project_google_image"
                                       class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                            </div>
                            <div class="flex">
                                <div class="mb-2 leading-tight mr-2 w-1/2">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('city')}" for="city">City</label>
                                    <input v-model="form.city" type="text" name="city" id="city"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('city')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('city')">{{
                                            form.errors.get('city')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 leading-tight w-1/2">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('state')}" for="state">State</label>
                                    <input v-model="form.state" type="text" name="state" id="state"
                                           maxlength="2"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('state')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('state')">{{
                                            form.errors.get('state')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex">
                                <div class="mb-2 leading-tight w-1/2 pr-1">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('zip')}" for="zip">Zip</label>
                                    <input v-model="form.zip" type="text" name="zip" id="zip"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('zip')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('zip')">{{
                                            form.errors.get('zip')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="mb-2 leading-tight flex">
                                <div class="w-4/5">
                                    <label class="text-grey-darkest text-sm" style="margin-right: 15px;"
                                           :class="{'text-red' : form.errors.has('contact_name')}" for="contact_name">Contact
                                        Name</label>
                                    <input @input="debounceFilter" @keyup="focusOn();focusOut()" @blur="focusOutOnBlur()" v-model="form.contact_name" type="text" name="contact_name" id="contact_name" style="width: 115%;"
                                           class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('contact_name')}" autocomplete="off">
                                    <div class="text-red text-xs" v-if="form.errors.has('contact_name')">
                                        {{form.errors.get('contact_name') }}
                                    </div>
                                    <div v-if="searchContacts.length > 0" id="searchContacts_list" style="display: none; z-index: 999; width: 160%;box-shadow: 0px 0px 3px 2px #dcdcdc; background-color: #f7f7f7; margin-top: 5px; font-weight: 500;
                                        border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; border-top: 0px !important; overflow-y: scroll; height: 300px; position: relative;">
                                        <div style="cursor: pointer;" class="d-flex justify-content-between p-1 contactDiv" v-for="contact in searchContacts" @click="populateContacts(contact)">
                                                <div :title="contact.name"   style="padding: 5px; overflow: hidden; white-space: nowrap; width: 150px; text-overflow: ellipsis; font-size: 12px; ">{{ contact.name }}</div>
                                                <div :title="contact.email" style="padding: 5px; color: blue; text-decoration: underline; overflow: hidden; text-overflow: ellipsis; width: 200px;font-size: 12px; ">{{ contact.email }}</div>
                                                <div :title="contact.cell" style="padding: 5px; overflow: hidden; white-space: nowrap; width: 150px; text-overflow: ellipsis; font-weight: 500;font-size: 12px;">
                                                    <formatted-phone
                                                        v-if="contact.cell"
                                                        :phone="contact.cell"
                                                        :masks="masks"/></div>
                                                <div :title="contact.company.name" style="padding: 5px; overflow: hidden; white-space: nowrap; width: 150px; text-overflow: ellipsis; font-weight: 500;font-size: 12px;">{{contact.company.name}}</div>

                                        </div>
                                    </div>
                                </div>
                                <div class=" flex justify-center">
                                    <div class="text-center cursor-pointer table mb-0" style="margin-left: 60px;margin-top: 23px;"
                                         @click.prevent.stop="openNewModal()">
                                        <i class="fa fa-user fa-2x"></i>
                                        <i class="fa fa-plus-circle text-teal" style="margin-left: -18px"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-2 leading-tight">
                                <label class="text-grey-darkest text-sm"
                                       :class="{'text-red' : form.errors.has('contact_email')}" for="contact_email">Email</label>
                                <input v-model="form.contact_email" type="text" name="contact_email" id="contact_email"
                                       class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                       :class="{'border-red': form.errors.has('contact_email')}">
                                <div class="text-red text-xs" v-if="form.errors.has('contact_email')">{{
                                        form.errors.get('contact_email')
                                    }}
                                </div>
                            </div>
                            <div class="flex">
                                <div class="mb-2 leading-tight mr-2 w-1/2">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('contact_phone')}" for="contact_phone">Phone</label>
                                    <input v-model="form.contact_phone" type="text" name="contact_phone"
                                           v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                           id="contact_phone"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('contact_phone')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('contact_phone')">{{
                                            form.errors.get('contact_phone')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 leading-tight w-1/2">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('contact_cell')}" for="contact_cell">Cell</label>
                                    <input v-model="form.contact_cell" type="text" name="contact_cell" id="contact_cell"
                                           v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('contact_cell')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('contact_cell')">{{
                                            form.errors.get('contact_cell')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex">
                                <div class="mb-2 leading-tight w-1/2 pr-1">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('contact_fax')}"
                                           for="contact_fax">Fax</label>
                                    <input v-model="form.contact_fax" type="text" name="contact_fax" id="contact_fax"
                                           v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('contact_fax')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('contact_fax')">{{
                                            form.errors.get('contact_fax')
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rounded bg-white shadow-md w-full lg:w-1/3 mb-4 mt-lg-0 lg:hidden">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Sales Activities</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div v-if="form.sales_behaviors.length > 0" v-for="(item,index) in form.sales_behaviors"
                                 class="flex mb-2 inline-block">
                                <div class="col-1 px-1 flex items-center" v-if="atLeastOneHasDate">
                                    <input v-if="item.date" type="checkbox" id="" name="" true-value="1" false-value="0"
                                           class="sales-behavior-checkbox"
                                           v-model="item.completed" @change="checkIsSalesActivityCompleted(item)">
                                </div>
                                <label class="text-grey-darkest text-sm col-6 px-1 mb-0 flex items-center">{{
                                        item.name
                                    }}:</label>
                                <div v-show="calendarAccess==0" class="flex px-1"
                                     :class="atLeastOneHasDate ? 'col-5' : 'col-6'">
                                    <datepicker v-model="item.date"
                                                :ref=item.name
                                                :format="masks.date_mask"
                                                :week-start="7"
                                                :use-utc="true"
                                                @keypress.enter.prevent="this.closeCalendar()"
                                                :wrapper-class="atLeastOneHasDate ? 'w-5/6 fullscreen-when-on-mobile' : 'w-full fullscreen-when-on-mobile '"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1">
                                    </datepicker>
                                    <button v-if="item.date" @click.prevent.stop="removeDate(item.name, index)"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none w-1/6">
                                        clear
                                    </button>
                                </div>
                                <div v-show="calendarAccess" class="flex px-1"
                                     :class="atLeastOneHasDate ? 'col-5' : 'col-6'">
                                    <datetime type="datetime" name="date"
                                              v-model="item.date" use12-hour
                                              :ref=item.name
                                              class="w-full"
                                              :week-start="7"
                                              :format="masks.date_time_mask"
                                              :use-utc="true"
                                              :minute-step="15"
                                              input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                              @input="form.errors.clear('start_date')">
                                    </datetime>
                                    <button v-if="item.date" @click.prevent.stop="removeDateTimePicker(index)"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none w-1/6">
                                        clear
                                    </button>

                                </div>
                            </div>
                            <div v-if="form.sales_behaviors.length === 0" class="mb-2">
                                <div class="text-grey-darkest text-sm">
                                    Your company does not currently have any sales behaviors.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="enablePrequalification" class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Prequalifications</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full lg:w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('relate_and_connect_id')}"
                                           for="relate_and_connect_id">Relate & Connect</label>
                                    <select name="relate_and_connect_id" id="relate_and_connect_id"
                                            v-model="form.relate_and_connect_id"
                                            class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('relate_and_connect_id')}"
                                            @change="resetValidationErrors('relate_and_connect_id')">
                                        <option selected></option>
                                        <option v-for="item in selects.relate_and_connect" :value="item.id">{{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('relate_and_connect_id')">{{
                                            form.errors.get('relate_and_connect_id')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full lg:w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('rules_of_engagement_id')}"
                                           for="rules_of_engagement_id">Rules of Engagement</label>
                                    <select name="rules_of_engagement_id" id="rules_of_engagement_id"
                                            v-model="form.rules_of_engagement_id"
                                            class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('rules_of_engagement_id')}"
                                            @change="resetValidationErrors('rules_of_engagement_id')">
                                        <option selected></option>
                                        <option v-for="item in selects.rules_of_engagement" :value="item.id">{{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('rules_of_engagement_id')">{{
                                            form.errors.get('rules_of_engagement_id')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full lg:w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('find_problems_id')}"
                                           for="find_problems_id">Find Problems</label>
                                    <select name="find_problems_id" id="find_problems_id"
                                            v-model="form.find_problems_id"
                                            class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('find_problems_id')}"
                                            @change="resetValidationErrors('find_problems_id')">
                                        <option selected></option>
                                        <option v-for="item in selects.find_problems" :value="item.id">{{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('find_problems_id')">{{
                                            form.errors.get('find_problems_id')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full lg:w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('money_step_id')}" for="money_step_id">Money
                                        Step</label>
                                    <select name="money_step_id" id="money_step_id"
                                            v-model="form.money_step_id"
                                            class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('money_step_id')}"
                                            @change="resetValidationErrors('money_step_id')">
                                        <option selected></option>
                                        <option v-for="item in selects.money_step" :value="item.id">
                                            {{ item.full_description }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('money_step_id')">{{
                                            form.errors.get('money_step_id')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full lg:w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('decision_process_id')}"
                                           for="decision_process_id">Decision Process</label>
                                    <select name="decision_process_id" id="decision_process_id"
                                            v-model="form.decision_process_id"
                                            class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('decision_process_id')}"
                                            @change="resetValidationErrors('decision_process_id')">
                                        <option selected></option>
                                        <option v-for="item in selects.decision_process" :value="item.id">{{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('decision_process_id')">{{
                                            form.errors.get('decision_process_id')
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Record Details</span>
                        </div>
                        <div class="py-3 px-3">
                            <div v-if="Object.keys(recordDetailFieldLabels).length > 0" class="row">
                                <div v-for="label in Object.keys(recordDetailFieldLabels)" :class="(label !== 'estimated-contract-date' || (label === 'estimated-contract-date' && team.has_probability_access)) ? 'col-xs-12 col-md-6' : ''">
                                    <div v-if="label === 'base-bid'">
                                        <label class="text-grey-darkest text-sm mt-2"
                                               :class="{'text-red' : form.errors.has('base_bid')}" for="base_bid">{{ getFieldLabel(recordDetailFieldLabels, 'base-bid') }}</label>
                                        <currency-input
                                            id="base_bid"
                                            name="base_bid"
                                            v-model="form.base_bid"
                                            locale="us"
                                            :currency="null"
                                            class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                            :class="{'border-red': form.errors.has('base_bid')}">
                                        </currency-input>
                                        <div class="text-red text-xs" v-if="form.errors.has('base_bid')">{{
                                                form.errors.get('base_bid')
                                            }}
                                        </div>
                                    </div>
                                    <div v-if="label === 'contract-amount'">
                                        <label class="text-grey-darkest text-sm mt-2"
                                               :class="{'text-red' : form.errors.has('contract_amount')}"
                                               for="contract_amount">{{ getFieldLabel(recordDetailFieldLabels, 'contract-amount') }}</label>
                                        <currency-input
                                            id="contract_amount"
                                            name="contract_amount"
                                            v-model="form.contract_amount"
                                            locale="us"
                                            :currency="null"
                                            class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                            :class="{'border-red': form.errors.has('contract_amount')}">
                                        </currency-input>
                                        <div class="text-red text-xs" v-if="form.errors.has('contract_amount')">{{
                                                form.errors.get('contract_amount')
                                            }}
                                        </div>
                                    </div>
                                    <div v-if="team.has_probability_access && label === 'estimated-contract-date'">
                                        <label class="text-grey-darkest text-sm mt-2"
                                               :class="{'text-red' : form.errors.has('estimated_contract_date')}">{{ getFieldLabel(recordDetailFieldLabels, 'estimated-contract-date') }}</label>
                                        <datepicker v-model="form.estimated_contract_date"
                                                    :format="masks.date_mask"
                                                    :use-utc="true"
                                                    @keypress.enter.prevent="this.closeCalendar()"
                                                    wrapper-class="fullscreen-when-on-mobile"
                                                    :input-class="form.errors.has('estimated_contract_date') ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1'"
                                                    @input="resetValidationErrors('estimated_contract_date')">
                                        </datepicker>
                                        <div class="text-red text-xs" v-if="form.errors.has('estimated_contract_date')">{{
                                                form.errors.get('estimated_contract_date')
                                            }}
                                        </div>
                                    </div>
                                    <div v-if="label === 'contract-date'">
                                        <label class="text-grey-darkest text-sm mt-2"
                                               :class="{'text-red' : form.errors.has('contract_date')}">{{ getFieldLabel(recordDetailFieldLabels, 'contract-date') }}</label>
                                        <datepicker v-model="form.contract_date"
                                                    :format="masks.date_mask"
                                                    :use-utc="true"
                                                    @keypress.enter.prevent="this.closeCalendar()"
                                                    wrapper-class="fullscreen-when-on-mobile"
                                                    :input-class="form.errors.has('contract_date') ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1'"
                                                    @input="resetValidationErrors('contract_date')">
                                        </datepicker>
                                        <div class="text-red text-xs" v-if="form.errors.has('contract_date')">{{
                                                form.errors.get('contract_date')
                                            }}
                                        </div>
                                    </div>
                                    <div v-if="label === 'gross-margin'">
                                        <label class="text-grey-darkest text-sm mt-2"
                                               :class="{'text-red' : form.errors.has('gross_margin_percentage')}"
                                               for="gross_margin_percentage">{{ getFieldLabel(recordDetailFieldLabels, 'gross-margin') }} %</label>
                                        <currency-input
                                            id="gross_margin_percentage"
                                            name="gross_margin_percentage"
                                            v-model="form.gross_margin_percentage"
                                            locale="us"
                                            :currency="null"
                                            class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                            :class="{'border-red': form.errors.has('gross_margin_percentage')}">
                                        </currency-input>
                                        <div class="text-red text-xs" v-if="form.errors.has('gross_margin_percentage')">{{
                                                form.errors.get('gross_margin_percentage')
                                            }}
                                        </div>
                                    </div>
                                    <div v-if="label === 'labor-hours'">
                                        <label class="text-grey-darkest text-sm mt-2"
                                               :class="{'text-red' : form.errors.has('labor_hours')}" for="labor_hours">{{ getFieldLabel(recordDetailFieldLabels, 'labor-hours') }}</label>
                                        <currency-input
                                            id="labor_hours"
                                            name="labor_hours"
                                            v-model="form.labor_hours"
                                            locale="us"
                                            :currency="null"
                                            class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                            :class="{'border-red': form.errors.has('labor_hours')}">
                                        </currency-input>
                                        <div class="text-red text-xs" v-if="form.errors.has('labor_hours')">{{
                                                form.errors.get('labor_hours')
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <project-record-detail-custom-fields
                                    ref="ProjectRecordDetailCustomFields"
                                    :project="null"
                                    :masks="masks"
                                    :customFieldErrors="form.errors"
                                >
                                </project-record-detail-custom-fields>
                            </div>
                        </div>
                    </div>
<!--                    <div v-if="changeOrderKey" id="change-order" class="rounded bg-white shadow-md">-->
<!--                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">-->
<!--                            <span>Change Orders</span>-->
<!--                        </div>-->
<!--                        <div class="pt-4 pb-2 px-3">-->
<!--                            <span v-for="(item,index) in change_order" >-->
<!--                                <div :id="`removeOrder`+index">-->
<!--                                    <div class="mb-2 ml-2 leading-tight w-full row">-->
<!--                                        <h6 class="mb-2">Change Order {{index + 1}}</h6>-->
<!--                                        <span class="hover:text-red" style="margin-left: 270px;"><i @click="deleteOrder(index)" class="material-icons">delete</i></span>-->
<!--                                    </div>-->
<!--                                    <div class="mb-2 ml-2 leading-tight w-full row">-->
<!--                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"-->
<!--                                           :class="{'text-red' : form.errors.has('sales_status_id')}"-->
<!--                                           for="sales_status_id">Sales Status</label>-->
<!--                                        <select name="sales_status_order" :id="`sales_status_order_`+index"-->
<!--                                                v-model="form.sales_status_id"-->
<!--                                                class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"-->
<!--                                                :class="{'border-red': form.errors.has('sales_status_id')}"-->
<!--                                                @change="resetValidationErrors('sales_status_id')">-->
<!--                                        <option selected></option>-->
<!--                                        <option v-for="item in selects.sales_status" :value="item.id">{{-->
<!--                                                item.full_description-->
<!--                                            }}-->
<!--                                        </option>-->
<!--                                    </select>-->
<!--                                    <div class="text-red text-xs" v-if="form.errors.has('sales_status_id')">{{-->
<!--                                            form.errors.get('sales_status_id')-->
<!--                                        }}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                    <div class="flex flex-wrap">-->
<!--                                    <div class="mb-2 ml-2 leading-tight w-full row">-->
<!--                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"-->
<!--                                               :class="{'text-red' : form.errors.has('contract_amount')}"-->
<!--                                               for="contract_amount">Contract Amount</label>-->
<!--                                        <currency-input-->
<!--                                            :id="`amount_`+index"-->
<!--                                            name="amount"-->
<!--                                            v-model="form.contract_amount"-->
<!--                                            locale="us"-->
<!--                                            :currency="null"-->
<!--                                            class="rounded w-1/2 md:w-2/3 p-1 text-grey-darkest text-sm focus:outline-none border-1"-->
<!--                                            :class="{'border-red': form.errors.has('contract_amount')}">-->
<!--                                        </currency-input>-->
<!--                                        <div class="text-red text-xs" v-if="form.errors.has('contract_amount')">{{-->
<!--                                                form.errors.get('contract_amount')-->
<!--                                            }}-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                    <div class="flex flex-wrap">-->
<!--                                    <div class="mb-2 ml-2 leading-tight w-full row">-->
<!--                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"-->
<!--                                               :class="{'text-red' : form.errors.has('contract_date')}">Contract-->
<!--                                            Date</label>-->
<!--                                        <div class="w-1/2 md:w-2/3 flex">-->
<!--                                            <datepicker v-model="form.contract_date" :format="masks.date_mask"-->
<!--                                                        @keypress.enter.prevent="closeCalendar()"-->
<!--                                                        :wrapper-class="isAdmin && form.contract_date ? 'w-4/5 fullscreen-when-on-mobile' : 'w-full fullscreen-when-on-mobile'"-->
<!--                                                        :input-class="form.errors.has('contract_date') ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1'"-->
<!--                                                        @input="resetValidationErrors('contract_date')">-->
<!--                                            </datepicker>-->
<!--                                            <button type="button" v-if="isAdmin && form.contract_date" @click="form.contract_date = ''"-->
<!--                                                    class="material-icons text-grey-darkest text-xl focus:outline-none w-1/5">-->
<!--                                                clear-->
<!--                                            </button>-->
<!--                                        </div>-->
<!--                                        <div class="text-red text-xs" v-if="form.errors.has('contract_date')">{{-->
<!--                                                form.errors.get('contract_date')-->
<!--                                            }}-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                </div>-->
<!--                            </span>-->
<!--                            <div class="flex flex-wrap">-->
<!--                                <button type="button" @click="ChangeOrder()" class="btn btn-primary" style="margin-left: 255px;">Add Change Order</button>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
                <div class="flex-col w-full lg:w-1/3 lg:mx-4 mt-4 mt-lg-0">
                    <div class="rounded bg-white shadow-md">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Project Data</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div v-if="Object.keys(fieldLabels).length > 0">
                                <div class="flex flex-wrap" style="flex-flow: column wrap;">
                                    <div v-for="label in Object.keys(fieldLabels)">

                                        <div v-if="label == 'sales-status'">
                                            <div class="mb-2 ml-2 leading-tight w-full row">
                                                <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                       :class="{'text-red' : form.errors.has('sales_status_id')}"
                                                       for="sales_status_id"> {{ getFieldLabel(fieldLabels, 'sales-status')}}</label>
                                                <select name="sales_status_id" id="sales_status_id" v-model="form.sales_status_id"
                                                        class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                                        :class="{'border-red': form.errors.has('sales_status_id')}"
                                                        @change="resetValidationErrors('sales_status_id')">
                                                    <option selected></option>
                                                    <option v-for="item in selects.sales_status" :value="item.id">
                                                        {{ item.full_description }}
                                                    </option>
                                                </select>
                                                <div class="text-red text-xs" v-if="form.errors.has('sales_status_id')">{{
                                                    form.errors.get('sales_status_id')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="label == 'marketing-status'">
                                            <div class="mb-2 ml-2 leading-tight w-full row">
                                                <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                       :class="{'text-red' : form.errors.has('marketing_status_id')}"
                                                       for="marketing_status_id">{{ getFieldLabel(fieldLabels, 'marketing-status')}}</label>
                                                <select name="marketing_status_id" id="marketing_status_id" v-model="form.marketing_status_id"
                                                        class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                                        :class="{'border-red': form.errors.has('marketing_status_id')}"
                                                        @change="resetValidationErrors('marketing_status_id')">
                                                    <option selected></option>
                                                    <option v-for="item in selects.marketing_status" :value="item.id">{{
                                                        item.full_description
                                                        }}
                                                    </option>
                                                </select>
                                                <div class="text-red text-xs" v-if="form.errors.has('marketing_status_id')">{{
                                                    form.errors.get('marketing_status_id')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="label == 'pre-bid'">
                                            <div class="mb-2 ml-2 leading-tight w-full row">
                                                <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                       :class="{'text-red' : form.errors.has('pre_bid')}">{{ getFieldLabel(fieldLabels, 'pre-bid')}}</label>
                                                <datepicker v-model="form.pre_bid" :format="masks.date_mask" :use-utc="true"
                                                            @keypress.enter.prevent="this.closeCalendar()" wrapper-class="fullscreen-when-on-mobile w-1/2 md:w-2/3"
                                                            :input-class="form.errors.has('pre_bid') ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1'"
                                                            @input="resetValidationErrors('pre_bid')"></datepicker>
                                                <div class="text-red text-xs" v-if="form.errors.has('pre_bid')">{{
                                                    form.errors.get('pre_bid')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="label == 'bid-date'">
                                            <div class="mb-2 ml-2 leading-tight w-full row">
                                                <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                       :class="{'text-red' : form.errors.has('bid_date')}">{{ getFieldLabel(fieldLabels, 'bid-date')}}</label>
                                                <datepicker v-model="form.bid_date" :format="masks.date_mask" :use-utc="true"
                                                            @keypress.enter.prevent="this.closeCalendar()" wrapper-class="w-1/2 md:w-2/3 fullscreen-when-on-mobile"
                                                            :input-class="form.errors.has('bid_date') ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1'"
                                                            @input="resetValidationErrors('bid_date')"></datepicker>
                                                <div class="text-red text-xs" v-if="form.errors.has('bid_date')">{{
                                                    form.errors.get('bid_date')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="label == 'lead-source'">
                                            <div class="mb-2 ml-2 leading-tight w-full row">
                                                <label class="text-grey-darkest text-sm w-1/2 md:w-1/3" :class="{'text-red' : form.errors.has('lead_from_id')}"
                                                       for="lead_from_id">{{ getFieldLabel(fieldLabels, 'lead-source')}}</label>
                                                <select name="lead_from_id" id="lead_from_id" v-model="form.lead_from_id"
                                                        class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                                        :class="{'border-red': form.errors.has('lead_from_id')}" @change="resetValidationErrors('lead_from_id')">
                                                    <option selected></option>
                                                    <option v-for="item in selects.lead_from" :value="item.id">
                                                        {{ item.full_description }}
                                                    </option>
                                                </select>
                                                <div class="text-red text-xs" v-if="form.errors.has('lead_from')">{{
                                                    form.errors.get('lead_from_id')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="label == 'estimator'">
                                            <div class="mb-2 ml-2 leading-tight w-full row">
                                                <label class="text-grey-darkest text-sm w-1/2 md:w-1/3" :class="{'text-red' : form.errors.has('estimator_id')}"
                                                       for="estimator_id">{{ getFieldLabel(fieldLabels, 'estimator')}}</label>
                                                <select name="estimator_id" id="estimator_id" v-model="form.estimator_id"
                                                        class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                                        :class="{'border-red': form.errors.has('estimator_id')}" @change="resetValidationErrors('estimator_id')">
                                                    <option selected></option>
                                                    <option v-for="item in selects.users" :value="item.id">{{ item.name }}</option>
                                                </select>
                                                <div class="text-red text-xs" v-if="form.errors.has('estimator_id')">{{
                                                    form.errors.get('estimator_id')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if=" label =='account-manager'">
                                            <div class="mb-2 ml-2 leading-tight w-full row">
                                                <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                       :class="{'text-red' : form.errors.has('account_manager_id')}"
                                                       for="account_manager_id">{{ getFieldLabel(fieldLabels, 'account-manager')}}</label>
                                                <select name="account_manager_id" id="account_manager_id" v-model="form.account_manager_id"
                                                        class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                                        :class="{'border-red': form.errors.has('account_manager_id')}"
                                                        @change="resetValidationErrors('account_manager_id')">
                                                    <option selected></option>
                                                    <option v-for="item in selects.users" :value="item.id">{{ item.name }}</option>
                                                </select>
                                                <div class="text-red text-xs" v-if="form.errors.has('account_manager_id')">{{
                                                    form.errors.get('account_manager_id')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="label == 'take-off-person'">
                                            <div class="mb-2 ml-2 leading-tight w-full row">
                                                <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                       :class="{'text-red' : form.errors.has('take_off_person_id')}"
                                                       for="take_off_person_id">{{ getFieldLabel(fieldLabels, 'take-off-person')}}</label>
                                                <select name="take_off_person_id" id="take_off_person_id" v-model="form.take_off_person_id"
                                                        class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                                        :class="{'border-red': form.errors.has('take_off_person_id')}"
                                                        @change="resetValidationErrors('take_off_person_id')">
                                                    <option selected></option>
                                                    <option v-for="item in selects.users" :value="item.id">{{ item.name }}</option>
                                                </select>
                                                <div class="text-red text-xs" v-if="form.errors.has('take_off_person_id')">{{
                                                    form.errors.get('take_off_person_id')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div  v-if="label == 'products-and-services'">
                                            <div class="mb-2 ml-2 leading-tight w-full row">
                                                <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                       :class="{'text-red' : form.errors.has('products_and_services_id')}"
                                                       for="products_and_services_id">{{ getFieldLabel(fieldLabels, 'products-and-services')}}</label>
                                                <select name="products_and_services_id" id="products_and_services_id" v-model="form.products_and_services_id"
                                                        class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                                        :class="{'border-red': form.errors.has('products_and_services_id')}"
                                                        @change="resetValidationErrors('products_and_services_id')">
                                                    <option selected></option>
                                                    <option v-for="item in selects.products_and_services" :value="item.id">{{
                                                        item.full_description
                                                        }}
                                                    </option>
                                                </select>
                                                <div class="text-red text-xs" v-if="form.errors.has('products_and_services_id')">{{
                                                    form.errors.get('products_and_services_id')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="label == 'client-profile'">
                                            <div class="mb-2 ml-2 leading-tight w-full row">
                                                <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                       :class="{'text-red' : form.errors.has('client_profile_id')}"
                                                       for="client_profile_id">{{ getFieldLabel(fieldLabels, 'client-profile')}}</label>
                                                <select name="client_profile_id" id="client_profile_id" v-model="form.client_profile_id"
                                                        class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                                        :class="{'border-red': form.errors.has('client_profile_id')}"
                                                        @change="resetValidationErrors('client_profile_id')">
                                                    <option selected></option>
                                                    <option v-for="item in selects.client_profile" :value="item.id">{{
                                                        item.full_description
                                                        }}
                                                    </option>
                                                </select>
                                                <div class="text-red text-xs" v-if="form.errors.has('client_profile_id')">{{
                                                    form.errors.get('client_profile_id')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="label == 'contract-type'">
                                            <div class="mb-2 ml-2 leading-tight w-full row">
                                                <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                       :class="{'text-red' : form.errors.has('contract_type_id')}"
                                                       for="contract_type_id">{{ getFieldLabel(fieldLabels, 'contract-type')}}</label>
                                                <select name="contract_type_id" id="contract_type_id" v-model="form.contract_type_id"
                                                        class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                                        :class="{'border-red': form.errors.has('contract_type_id')}"
                                                        @change="resetValidationErrors('contract_type_id')">
                                                    <option selected></option>
                                                    <option v-for="item in selects.contract_type" :value="item.id">
                                                        {{ item.full_description }}
                                                    </option>
                                                </select>
                                                <div class="text-red text-xs" v-if="form.errors.has('contract_type_id')">{{
                                                    form.errors.get('contract_type_id')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div  v-if=" label =='office'">
                                            <div class="mb-2 ml-2 leading-tight w-full row">
                                                <label class="text-grey-darkest text-sm w-1/2 md:w-1/3" :class="{'text-red' : form.errors.has('office_id')}"
                                                       for="office_id">{{ getFieldLabel(fieldLabels, 'office')}}</label>
                                                <select name="office_id" id="office_id" v-model="form.office_id"
                                                        class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                                        :class="{'border-red': form.errors.has('office_id')}" @change="resetValidationErrors('office_id')">
                                                    <option selected></option>
                                                    <option v-for="item in selects.office" :value="item.id">{{
                                                        item.full_description
                                                        }}
                                                    </option>
                                                </select>
                                                <div class="text-red text-xs" v-if="form.errors.has('office_id')">{{
                                                    form.errors.get('office_id')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <project-custom-fields ref="CustomFields" :project="reference" :customFieldErrors="form.errors" :selects="selects" :salesStatusId="form.sales_status_id" :masks="masks" status="create" :foundationContactSyncAccess="foundationContactSyncAccess" :foundationAutoGeneratedJobNo="foundationAutoGeneratedJobNo" :foundationAutoGeneratedAccess="foundationAutoGeneratedAccess" v-on:custom-field-response="projectCustomFieldResponse" :team="team"></project-custom-fields>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rounded bg-white shadow-md lg:w-1/3 mt-4 mt-lg-0 hidden lg:inline">
                    <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                        <span>Sales Activities</span>
                    </div>
                    <div class="pt-4 pb-2 px-3">
                        <div v-if="form.sales_behaviors.length > 0" v-for="(item,index) in form.sales_behaviors"
                             class="flex mb-2 inline-block">
                            <div class="col-1 px-1 flex items-center" v-if="atLeastOneHasDate">
                                <input v-if="(item.date && typeof item.date === 'string') && !item.follow_up" type="checkbox" id="" name="" true-value="1"
                                       false-value="0" class="sales-behavior-checkbox"
                                       v-model="item.completed" @change="checkIsSalesActivityCompleted(item)">
                            </div>
                            <label class="text-grey-darkest text-sm col-6 px-1 mb-0 flex items-center" :class="{'text-red' : form.errors.has(item.name)}">{{
                                    item.name
                                }}:</label>
                            <div v-show="calendarAccess===0" class="flex px-1"
                                 :class="atLeastOneHasDate ? 'col-5' : 'col-6'">
                                <datepicker v-model="item.date"
                                            valueType="format"
                                            :ref=item.name
                                            :format="masks.date_mask"
                                            :use-utc="true"
                                            :week-start="7"
                                            @keypress.enter.prevent="this.closeCalendar()"
                                            :wrapper-class="atLeastOneHasDate ? 'w-5/6 fullscreen-when-on-mobile' : 'w-full fullscreen-when-on-mobile '"
                                            :input-class="form.errors.has(item.name) ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1'">
                                </datepicker>

                                <button v-if="item.date" @click.prevent.stop="removeDate(item.name, index)"
                                        class="material-icons text-grey-darkest text-xl focus:outline-none w-1/6">clear
                                </button>

                            </div>
                            <div v-show="calendarAccess" class="flex px-1"
                                 :class="atLeastOneHasDate ? 'col-5' : 'col-6'">
                                <projectDatetime type="datetime"
                                          name="date" :id="`datetime-${index}`"
                                          v-model="item.date" use12-hour
                                          :ref="`datepicker-${index}`"
                                          autofill="off"
                                          class="w-full"
                                          :week-start="7"
                                          :format="masks.date_time_mask"
                                          :use-utc="true"
                                          :minute-step="15"
                                          :input-class="form.errors.has(item.name) ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1'"
                                          @input="form.errors.clear('start_date'); resetValidationErrors(item.name);">
                                </projectDatetime>
                                <button v-if="item.date && typeof item.date === 'string'" @click.prevent.stop="removeDateTimePicker(index)"
                                        class="material-icons text-grey-darkest text-xl focus:outline-none w-1/6">
                                    clear
                                </button>
                            </div>
<!--                            <div class="text-red text-xs" v-if="form.errors.has(item.name)">-->
<!--                                {{form.errors.get(item.name)}}-->
<!--                            </div>-->
                        </div>
                        <div v-if="form.sales_behaviors.length === 0" class="mmb-2b-2">
                            <div class="text-grey-darkest text-sm">
                                Your company does not currently have any sales behaviors.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rounded bg-white shadow-md mb-64">
                <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                    <span>Company Information</span>
                </div>
                <company-information
                    ref="ProjectCompanyInformation"
                    :project="reference"
                    :errors="form.errors"
                    :allCompanies="allCompanies"
                    :masks="masks"
                    :savedContacts=[]
                    :usersForContact="usersForContact"
                    :allContactTypes="all_contact_types"
                    :foundationCustomerAccess="foundationCustomerAccess"
                    :sageIntacctContactSyncAccess="sageIntacctContactSyncAccess"
                    :foundationContactSyncedErrorMsg="foundationContactSyncedErrorMsg"
                    :sageIntacctContactSyncedErrorMsg="sageIntacctContactSyncedErrorMsg"
                    :foundationContactSyncAccess="foundationContactSyncAccess"
                    :sectionType="(form.company_contacts.length > 0) ? 'projectCopy' : 'projectCreate'"
                    :resetValidationErrors="resetValidationErrors"
                    :symbols="symbols"
                    :canEdit=false
                    :addComment=null
                    :companyContactIds=null
                    :team="team"
                    :mailSubject=null
                    :companyWonStatusRequired=null
                    :teamResidentialContactType="teamResidentialContactType"
                    :canCreateCompany="canCreateCompany"
                ></company-information>

            </div>
        </form>
        <!-- Modal Popup -->
        <div class="modal" id="exampleModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 400px;">
                    <div class="modal-header">
                        <div class="row">
                            <div class="col-md-12" style="text-align: center; font-size:20px; margin-top: 10px;">Add a Contact</div>
                            <div class="col-md-12" style="text-align: center; margin-top: 32px;">
                                <button type="button" class="btn btn-primary" style="padding: 20px;box-shadow: #989797 0px 0px 5px 2px;margin-right: 12px;"
                                @click="openNewCompanyContactModal"> Company Contact</button>
                                <button type="button" class="btn btn-primary" style="padding: 20px;box-shadow: #989797 0px 0px 5px 2px;"
                                @click="openEmailContactModal">Email Contact</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="addToAddressBookModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 400px;">
                    <div class="modal-header">
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <p class="m-4">Do you want to add this contact to Company Address Book?</p>
                                <button type="button" class="btn btn-primary mr-2"
                                        data-dismiss="modal" @click="addContactToAddressBook">Add</button>
                                <button type="button" class="btn btn-danger ml-2"
                                        data-dismiss="modal" aria-label="Close" @click="saveWithoutContact">No</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>



        <!-- Modal -->
        <div id="newContactToAddressBookModal" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">Add To Company Address Book</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal" @click="savedAfterCheck()">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="newAddressBookContactForm.errors.clear($event.target.name)">
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('existing_company')}">Add to Existing Company</label>
                                <multiselect class="cursor-pointer" id="existing" :options="allCompanies" v-model="newAddressBookContactForm.existing_company" :show-labels="false"
                                             @input="newAddressBookContactForm.errors.clear('existing_company')"
                                             @select="remove_validations();disableToggle()"
                                             @remove="removeDisable()"
                                             track-by="id" label="name" value="id"
                                             :disabled="is_true"
                                ></multiselect>
                                <div class="text-red" v-if="newAddressBookContactForm.errors.has('company_id')">{{ form.errors.get('company_id') }}</div>
                                <div class="text-red" v-show="customErrors.existing_company != null">{{ customErrors.existing_company }}</div>
                            </div>
                            <div class="mb-2">
                                <label class="text-grey-darkest text-sm" :class="{'text-red': newAddressBookContactForm.errors.has('new_company')}">Add New Company</label>
                                <input v-model="newAddressBookContactForm.new_company" id="new_company" name="new_company"
                                       class="leading-normal tracking-wide appearance-none border-1 rounded py-1 px-3 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': form.errors.has('new_company')}" @keypress="remove_validations();disableExistingCompany()" @keyup="enableDropdown()"
                                       @paste = "onPaste">
                                <div class="text-red" v-if="newAddressBookContactForm.errors.has('new_company')">{{ newAddressBookContactForm.errors.get('new_company') }}</div>
                                <div class="text-red" v-show="customErrors.new_company != null">{{ customErrors.new_company }}</div>
                            </div>

                            <div class="mb-2">
                                <label class="text-grey-darkest text-sm" for="address_book_contact_name"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('name')}">Name</label>
                                <input v-model="newAddressBookContactForm.name" id="address_book_contact_name" name="name"
                                       maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': newAddressBookContactForm.errors.has('name')}">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('name')">{{
                                        newAddressBookContactForm.errors.get('name')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2" v-show="(teamResidentialContactType && teamResidentialContactType.id && newAddressBookContactForm.contact_types_id === teamResidentialContactType.id)">
                                <label class="text-grey-darkest text-sm" for="searchTextFieldContact"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('address')}">Address</label>
                                <input v-model="newAddressBookContactForm.address" id="searchTextFieldContact" name="address"
                                       maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': newAddressBookContactForm.errors.has('address')}">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('address')">{{
                                        newAddressBookContactForm.errors.get('address')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2" v-show="(teamResidentialContactType && teamResidentialContactType.id && newAddressBookContactForm.contact_types_id === teamResidentialContactType.id)">
                                <label class="text-grey-darkest text-sm" for="address_book_contact_city"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('city')}">City</label>
                                <input v-model="newAddressBookContactForm.city" id="address_book_contact_city" name="city"
                                       maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': newAddressBookContactForm.errors.has('city')}">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('city')">{{
                                        newAddressBookContactForm.errors.get('city')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2" v-show="(teamResidentialContactType && teamResidentialContactType.id && newAddressBookContactForm.contact_types_id === teamResidentialContactType.id)">
                                <label class="text-grey-darkest text-sm" for="address_book_contact_state"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('state')}">State</label>
                                <input v-model="newAddressBookContactForm.state" id="address_book_contact_state" name="state"
                                       maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': newAddressBookContactForm.errors.has('state')}">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('state')">{{
                                        newAddressBookContactForm.errors.get('state')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2" v-show="(teamResidentialContactType && teamResidentialContactType.id && newAddressBookContactForm.contact_types_id === teamResidentialContactType.id)">
                                <label class="text-grey-darkest text-sm" for="address_book_contact_zip"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('zip')}">Zip</label>
                                <input v-model="newAddressBookContactForm.zip" id="address_book_contact_zip" name="zip"
                                       maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': newAddressBookContactForm.errors.has('zip')}">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('zip')">{{
                                        newAddressBookContactForm.errors.get('zip')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="address_book_email"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('email')}">Email</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    :class="{'border-red': newAddressBookContactForm.errors.has('email')}"
                                    type="text" id="address_book_email" v-model="newAddressBookContactForm.email">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('email')">{{
                                        newAddressBookContactForm.errors.get('email')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="address_book_cell"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('cell')}">Cell</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    type="text" id="address_book_cell" v-model="newAddressBookContactForm.cell">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('cell')">{{
                                        newAddressBookContactForm.errors.get('cell')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="address_book_contact_title"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('title')}">Title</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    type="text" id="address_book_contact_title" v-model="newAddressBookContactForm.title">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('title')">{{
                                        newAddressBookContactForm.errors.get('title')
                                    }}
                                </div>
                            </div>
<!--                            <div class="mb-2">-->
<!--                                <label class="text-sm text-grey-darkest -mb-0" for="new_contact_date"-->
<!--                                       :class="{'text-red': newAddressBookContactForm.errors.has('date')}">Follow Up</label>-->
<!--                                <div class="flex">-->
<!--                                    <datetime type="datetime" id="new_contact_date" name="date"-->
<!--                                              v-model="newAddressBookContactForm.date" use12-hour-->
<!--                                              class="w-full"-->
<!--                                              :week-start="7"-->
<!--                                              :format="masks.date_time_mask"-->
<!--                                              :use-utc="true"-->
<!--                                              input-class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"-->
<!--                                              @input="newAddressBookContactForm.errors.clear('date')">-->
<!--                                    </datetime>-->
<!--                                    <button v-if="newAddressBookContactForm.date" @click.prevent.stop="removeNewContactDate"-->
<!--                                            class="material-icons text-grey-darkest text-xl focus:outline-none">clear-->
<!--                                    </button>-->
<!--                                </div>-->
<!--                                <div class="text-red text-xs" v-if="newContactForm.errors.has('date')">{{-->
<!--                                        newContactForm.errors.get('date')-->
<!--                                    }}-->
<!--                                </div>-->
<!--                            </div>-->
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('contact_types_id')}">Contact Type</label>
                                <multiselect
                                    class="cursor-pointer"
                                    :options="all_contact_types"
                                    v-model="selectedAddressBookContactType"
                                    :show-labels="false"
                                    @input="newAddressBookContactForm.errors.clear('contact_types_id')"
                                    track-by="id"
                                    label="code"
                                    value="id">
                                </multiselect>
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('contact_types_id')">
                                    The contact type field is required.
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="addressBookContactSaved" :disabled="addressBookContactSavedButton"
                                class="btn btn-primary">
                            <span v-if="adding_contact">
                                <i class="fa fa-btn fa-spinner fa-spin" ></i>
                                Adding Contact
                            </span>
                            <span v-else>
                                Add Contact
                            </span>
                        </button>
                        <button type="button" class="btn btn-danger ml-2"
                                data-dismiss="modal" aria-label="Close" @click="savedAfterCheck()">Cancel</button>
                    </div>
                </div>

            </div>
        </div>


        <company-contact-modal ref="CompanyContactModal" :masks="this.masks" :symbols="this.symbols" :exchange="this.exchange"
                               @selected="parseContact"></company-contact-modal>
        <project-contact-modal ref="EmailContactModal" :masks="this.masks" :symbols="this.symbols" :exchange="this.exchange" :externalEmailService="externalEmailService" @selected="parseContact"></project-contact-modal>
<!--        <company-create-modal ref="CompanyCreateModal" :masks="this.masks" :symbols="this.symbols" :exchange="exchange" :externalEmailService="externalEmailService" :foundationCustomerAccess="foundationCustomerAccess" :foundationAutoGeneratedAccess="foundationAutoGeneratedAccess" @inserted="fetchCompanies"></company-create-modal>-->
        <div id="projectSaleBehaviorCompleteCommentModal" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog" style="max-width: 870px">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 v-if="tempSalesActivity" class="modal-title text-lg">
                            {{tempSalesActivity.name}} comment
                        </h4>
                    </div>
                    <div class="modal-body">
                        <form @keydown="form.errors.clear($event.target.name)">

                            <div class="mb-2">
                                <ckeditor-container placeholder="Send your colleagues on FollowUp notifications by typing @ followed by their name" id="comment" v-model="form.comment" :options="users"
                                                    @mention="addMention" mentionFrom="name"></ckeditor-container>
                                <div class="text-red text-xs" v-if="form.errors.has('comment')">{{
                                        form.errors.get('comment')
                                    }}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <span v-if="this.form.saving">
                            <button type="button" disabled
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                <i class="fa fa-btn fa-spinner fa-spin"></i> Saving
                            </button>
                        </span>
                        <span v-else>
                            <button type="button" id="save-project-comment" name="save-project-comment"
                                    @click.prevent="projectSalesActivityCommentSaved"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Save
                            </button>
                        </span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>

import Form from "../../utils/form";
import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';
import {CurrencyInput} from 'vue-currency-input';
import Swal from "sweetalert2";
import axios from "axios";
import CompanyInformation from "./company-information.vue";
import ProjectRecordDetailCustomFields from "./custom-fields/project-record-detail-custom-fields.vue";

let autocomplete=null;
let autocompleteContact=null;

export default {
    name: 'project-create',
    props: ['company', 'reference', 'calendar','masks', 'symbols', 'related', 'confettiPath','user','exchange', 'changeOrderKey', 'team', 'contact', 'enablePrequalification', 'fieldLabels', 'contactToAddressBook','externalEmailService', 'foundationContactSyncAccess', 'foundationAutoGeneratedJobNo', 'foundationCustomerAccess', 'foundationAutoGeneratedAccess', 'isCompanyHasCustomCustomerNoField', 'isCompanyCustomCustomerNoAutoGenerated', 'isContactHasCustomCustomerNoField', 'isContactCustomCustomerNoAutoGenerated', 'sageIntacctContactSyncAccess', 'isContactResidentialActive', 'teamResidentialContactType',
            'recordDetailFieldLabels', 'canCreateCompany'],

    components: {ProjectRecordDetailCustomFields, CompanyInformation, Datepicker, Multiselect, CurrencyInput},

    data() {
        return {
            change_order:[
                {
                    sales_status: '',
                    contract_amount: '',
                    contract_date: '',
                }
            ],
            address:'',
            calendarAccess: 0,
            allCompanies: [],
            contacts: [],
            searchContacts: [],
            users: [],
            contact_type_options: [],
            selectedTypeContact: null,
            selectedUserContact: null,
            selectedAddressBookContactType: null,
            selectedCompany: null,
            options: {
                format: this.masks.moment_mask,
                useCurrent: false,
            },
            selects: {},
            form: new Form({
                company_contacts: [],
                name: '',
                bid_bond: 0,
                address: '',
                city: '',
                state: '',
                zip: '',
                lat: '',
                lng: '',
                project_google_image: '',
                contact_name: '',
                contact_email: '',
                contact_phone: '',
                contact_cell: '',
                contact_fax: '',
                relate_and_connect_id: '',
                rules_of_engagement_id: '',
                find_problems_id: '',
                money_step_id: '',
                decision_process_id: '',
                base_bid: null,
                contract_amount: null,
                estimated_contract_date: '',
                contract_date: '',
                gross_margin_percentage: null,
                labor_hours: null,
                sales_status_id: '',
                marketing_status_id: '',
                pre_bid: '',
                bid_date: '',
                lead_from_id: '',
                estimator_id: '',
                account_manager_id: '',
                take_off_person_id: '',
                products_and_services_id: '',
                client_profile_id: '',
                contract_type_id: '',
                office_id: '',
                sales_behaviors: [],
                contact_company_id:'',
                relatedProject: this.related ?? null,
                custom_fields: [],
                check_contact_in_address_book: true,
                userTimeZoneName: null,
                userTimeZoneOffset: null,
                foundationContactSelectedContact: null,
                sageIntacctContactSelectedContact: null,
                customFieldsData: null,
                recordDetailCustomFieldForm: null,
                recordDetailCustomFields: []
            }),
            newContactForm: new Form({
                id: null,
                name: '',
                email: '',
                cell: '',
                title: '',
                date: null,
                completed: null,
                contact_types_id: null,
                user: null,
            }),
            newAddressBookContactForm: new Form({
                id: null,
                name: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                lat: '',
                lng: '',
                email: '',
                cell: '',
                title: '',
                date: null,
                completed: null,
                contact_types_id: null,
                company_id: null,
                existing_company: null,
                new_company: null,
            }),
            customErrors : {
                'existing_company': null,
                'new_company': null
            },
            is_true: false,
            addressBookContactSavedButton: false,
            adding_contact: false,
            autocomplete:null,
            page: 1,
            filter: '',
            data: '',
            optionsLinkedin:[
                { value: 'PUBLIC', text: 'PUBLIC' },
                { value: 'CONNECTIONS', text: 'CONNECTIONS' },
            ],
            formLinkedin: new Form({
                note: '',
                project_google_image: '',
                visibility: 'PUBLIC',
                name: '',
                address: '',
            }),
            isActiveShareButton:false,
            saveButtonDisabled: false,
            isValidateRequiredField: {
                isRequired:false,
                isContractAmountRequired:false,
            },
            formErrorObj: {
                field: '',
                msg: ''
            },
            usersForContact: [],
            savingProject: false,
            foundationContactSyncedErrorMsg: '',
            contact_custom_fields: [],
            company_custom_fields: [],
            // external_custom_fields: [],
            externalFoundationCustomFieldValue: null,
            // externalCustomFieldModalTitle: '',
            selectedContactForPushFoundation: null,
            // foundationContactPushLoader: false,
            selectedContactForPushSageIntacct: null,
            sageIntacctContactPushLoader: false,
            sageIntacctContactSyncedErrorMsg: '',
            sageIntacctSyncAction: '',
            all_contact_types: [],
            residential_contact_type: {},
            completedSalesBehaviorsForSegment: [],
            tempSalesActivity: null,
        }
    },
    mounted(){
        //this.$refs.address.focus();
        this.initAutocomplete();
        this.initAutocompleteContact();

        this.updateLinkedinForm();

        Bus.$on('openEmailContactModalParent', data => {
            $('#modal-contact').modal('hide');
            this.$refs.CompanyContactModal.close();
            this.$refs.EmailContactModal.open();

        });

        Bus.$on('openCompanyContactModal', data => {
            this.$refs.EmailContactModal.close();
            this.$refs.CompanyContactModal.open();

        });

        this.fetchContactCustomFields();
        this.fetchCompanyCustomFields();


    },

    created() {
        this.calendarAccess = this.calendar;
        this.fetchCompanies();
        this.fetchCodes();
        this.fetchTeamUsers();
        this.fetchSalesBehaviors();
        this.getContactTypes();
        if (this.reference) this.parseReference();
        this.fetchData();
    },

    computed: {
        atLeastOneHasDate() {
            return _.some(this.form.sales_behaviors, (item) => item.date);
        },
        previewStyle() {
            return `background-image: url(${this.user.photo_url})`;
        },
    },

    watch: {
        'form.contract_amount': function (value) {
            // this.validateContractAmount();
        },
        'form.sales_status_id': function (value, oldValue) {
            const salesStatus = _.find(this.selects.sales_status, {id: value});

            if (salesStatus.contract == true && !this.form.contract_date) {
                this.form.contract_date = new Date();
            }

            // if(this.foundationContactSyncAccess) {
            //     this.validateContactWithContractSaleStatus(value, oldValue);
            // }
            // if(this.sageIntacctContactSyncAccess) {
            //     this.validateContactWithContractSaleStatus(value, oldValue);
            // }
        },
        selectedUserContact: function (user) {
            this.newContactForm.user = user;
        },
        selectedTypeContact(type) {
            this.newContactForm.contact_types_id = type.id;
        },
        selectedAddressBookContactType(type) {
            if (this.residential_contact_type.id === type.id){
                this.is_true = true;
                this.newAddressBookContactForm.existing_company = null;
                this.newAddressBookContactForm.new_company = null;
                document.getElementById("new_company").disabled = true;
            }else {
                this.is_true = false;
                document.getElementById("new_company").disabled = false;
            }

            this.newAddressBookContactForm.contact_types_id = type.id;
        },
        'form.contact_name': function (value) {
            if(this.form.errors.errors.contact_name && value !== null) {
                delete this.form.errors.errors.contact_name;
            }
        },
        'form.contact_email': function (value) {
            if(this.form.errors.errors.contact_email && value !== null) {
                delete this.form.errors.errors.contact_email;
            }
        },
        'form.contact_phone': function (value) {
            if(this.form.errors.errors.contact_phone && value !== null) {
                delete this.form.errors.errors.contact_phone;
            }
        },
        'form.name': function (value) {
            this.formLinkedin.name =  this.form.name;
        },
        'form.address': function (value) {
            this.formLinkedin.address = this.form.address;
        },
        'form.project_google_image': function (value) {
            this.formLinkedin.project_google_image = this.form.project_google_image;
        },
        'form.company_contacts': function (value) {
            if(this.form.company_contacts.length > 0) {
                this.resetValidationErrors('company_contacts');
                if(_.findIndex(this.form.company_contacts, function(contact) { return contact.foundation_customer_no !== null; }) === -1) {
                    this.foundationContactSyncedErrorMsg = 'None of the contacts added is synced with Foundation';
                }
                else {
                    this.foundationContactSyncedErrorMsg = '';
                }
                if(_.findIndex(this.form.company_contacts, function(contact) { return contact.sage_intacct_customer_no !== null; }) === -1) {
                    this.sageIntacctContactSyncedErrorMsg = 'None of the contacts added is synced with Sage Intacct';
                }
                else {
                    this.sageIntacctContactSyncedErrorMsg = '';
                }
            }
            else {
                this.foundationContactSyncedErrorMsg = '';
                this.sageIntacctContactSyncedErrorMsg = '';
            }
        },
        externalFoundationCustomFieldValue() {
            this.validateFoundationCustomerNumber();
        }
    },

    methods: {
        getValidDateString(date) {
            return typeof date === 'string' ? date : '';
        },
        updateLinkedinForm(){
          this.formLinkedin.project_google_image = this.form.project_google_image;
          this.formLinkedin.name =  this.form.name;
          this.formLinkedin.address = this.form.address ;
        },
        shareLinkedin() {
            this.isActiveShareButton = true;
            this.formLinkedin.post(route('api.project.post.share.linkedin')).then((resp) => {
                this.isActiveShareButton = false;
                if (resp.status) {
                    this.getToast().fire({
                        type: 'success',
                        title: resp.message
                    });
                    setTimeout(() => {

                        window.location = (this.company && !this.contact) ? route('company.show', {company: this.company.id}) : route('project.edit', {project: this.data.project_id});
                    }, 2000);
                } else {
                    this.getToast().fire({
                        type: 'error',
                        title: resp.message
                    });
                }
                $("#projectShareLinkedIn").modal("hide");
            }).catch((error) => {
                this.isActiveShareButton = false;
                console.log('error', error);
            });

        },
        openEmailContactModal() {
            $('#exampleModal').modal('hide');
            this.$refs.EmailContactModal.open();
        },
        openNewCompanyContactModal(){
            $('#exampleModal').modal('hide');
            this.$refs.CompanyContactModal.open();
        },
        openNewCompaniesContactModal(){
            $('#exampleModal').modal('hide');
            this.$refs.CompaniesContactModal.open();
        },
        parseCompanyContacts(contact) {
            this.newContactForm.name = contact.name;
            if (contact.phone){
                this.newContactForm.cell = contact.phone;
            }else {
                this.newContactForm.cell = contact.cell;
            }
            this.newContactForm.email = contact.email;
        },
        parseContact(contact) {
            if($('#newContactModal').hasClass('show')){
                this.newContactForm.name = contact.name;
                if (contact.phone){
                    this.newContactForm.cell = contact.phone;
                }else {
                    this.newContactForm.cell = contact.cell;
                }
                this.newContactForm.email = contact.email;
            }else {
                if (this.form.contact_email){
                    if (this.contact){
                        if (this.form.contact_email !== this.contact.email){
                            this.removeCompanyContact(this.form.contact_email)
                        }
                    }else {
                        this.removeCompanyContact(this.form.contact_email)
                    }
                }
                this.form.contact_name = contact.name;
                if (contact.phone){
                    this.form.contact_cell = contact.phone;
                }else {
                    this.form.contact_cell = contact.cell;
                }
                this.form.contact_email = contact.email;
                contact.id = contact.company_contact_id;
                if (typeof contact.id !== "undefined"){
                    if(!this.$refs.ProjectCompanyInformation.checkContactAlreadyExists(contact.id, contact.company_id)) {
                        this.$refs.ProjectCompanyInformation.addContact(contact, true);
                    }
                }
            }
        },
        populateCompanyContact(contact) {
            this.form.contact_name = contact.name;
            if (contact.phone){
                this.form.contact_cell = contact.phone;
            }else {
                this.form.contact_cell = contact.cell;
            }
            this.form.contact_email = contact.email;
            this.form.company_contacts.push(contact);
        },
        openNewModal(){
            $('#exampleModal').modal('show');
        },
        initAutocomplete() {
            let input = document.getElementById('searchTextField');
            autocomplete = new google.maps.places.Autocomplete(input, {
                componentRestrictions: {
                    country: ['us','ca']
                }
            });

            google.maps.event.addListener(autocomplete, 'place_changed', this.getAddressComponents);
        },

        getAddressComponents() {
            let placeResultData = autocomplete.getPlace();
            this.form.lat = placeResultData.geometry.location.lat();
            this.form.lng = placeResultData.geometry.location.lng();
            this.form.zip = '';
            this.form.city = '';
            this.form.state = '';
            this.form.project_google_image = '';
            var photos = placeResultData.photos;
            var mapOptions = {
                center: new google.maps.LatLng(this.form.lat, this.form.lng),
                zoom: 12,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            placeResultData.address_components.map(res=>{
                if(res.types[0]==='postal_code'){
                    this.form.zip = res.short_name;
                }
                if(res.types[0]==='locality'){
                    this.form.city = res.short_name;
                }
                if(res.types[0]==='administrative_area_level_1'){
                    this.form.state = res.short_name;
                }
            });
            this.form.address = placeResultData.name;
            this.address = placeResultData.name;
            if (photos) {
                this.form.project_google_image = photos[0].getUrl();
            }else {
                this.export(mapOptions);
            }
        },
        getAddressData: function (addressData, placeResultData, id) {
            this.form.zip = '';
            this.form.city = '';
            this.form.state = '';
            placeResultData.address_components.map(res=>{
                if(res.types[0]==='postal_code'){
                    this.form.zip = res.short_name;
                }
                if(res.types[0]==='locality'){
                    this.form.city = res.short_name;
                }
                if(res.types[0]==='administrative_area_level_1'){
                    this.form.state = res.short_name;
                }
            });
        },
        getAddress: function (addressData){
            if(addressData.newVal===""){
                this.form.state='';
                this.form.city='';
                this.form.zip='';
            }
            const shortAddress  = addressData.newVal.split(",");
            this.form.address = shortAddress[0];

        },
        export(mapOptions) {
            var staticMapUrl = "https://maps.googleapis.com/maps/api/staticmap";
            staticMapUrl += "?center=" + mapOptions.center.lat() + "," + mapOptions.center.lng();
            staticMapUrl += "&size=640x440";
            staticMapUrl += "&zoom=" + mapOptions.zoom;
            staticMapUrl += "&maptype=" + mapOptions.mapTypeId;
            staticMapUrl += "&markers=color:red%7C"+this.form.address.replace(/\s+/g,"+");
            staticMapUrl += "&key=AIzaSyC5C-qX6oo7TeQGsCWasvGgJvU5evBBpPg";
            this.form.project_google_image = staticMapUrl;
        },
        fetchCompanies(newCompany = null) {
            axios.get(route('api.project.companies')).then(({data}) => {
                this.allCompanies = data.data;

                if (newCompany) this.handleNewCompany(newCompany);
                this.addCompanyContact();
            })
        },

        // fetchContacts() {
        //     if (this.selectedCompany) {
        //         axios.get(route('api.company.contacts', {company: this.selectedCompany.id})).then(({data}) => {
        //             this.contacts = data.data;
        //         });
        //     } else {
        //         this.contacts = [];
        //     }
        // },

        fetchTeamUsers() {
            axios.get(route('api.team-users')).then(({data}) => {
                this.users = data;
            })
        },

        fetchCodes() {
            axios.get(route('api.project.codes')).then(({data}) => {
                this.selects = data;
                this.usersForContact = this.selects.users;
                if (this.reference) {
                    let ss = _.find(data.sales_status, {code: 'Pending'});
                    if (ss) this.form.sales_status_id = ss.id;
                }

                let kanbanColumnToAdd = localStorage.getItem('kanban-group-by');
                let kanbanValueToAdd =localStorage.getItem('kanban-column');
                let kanbanSwimlaneRowToAdd =localStorage.getItem('kanban-sub-group-by');
                let kanbanSwimlaneValueToAdd =localStorage.getItem('kanban-row');
                if(kanbanColumnToAdd && kanbanValueToAdd && kanbanValueToAdd !== 'Unassigned' && kanbanValueToAdd !== null && kanbanValueToAdd !== "null"){
                console.log('234234234234234234', kanbanColumnToAdd, kanbanValueToAdd, kanbanSwimlaneValueToAdd);
                    this.form[kanbanColumnToAdd] = kanbanValueToAdd;

                    setTimeout(() => {
                        localStorage.removeItem('kanban-group-by');
                        localStorage.removeItem('kanban-column');
                    }, 2000);
                }

                if(kanbanSwimlaneRowToAdd && kanbanSwimlaneValueToAdd && kanbanSwimlaneValueToAdd !== 'Unassigned' && kanbanSwimlaneValueToAdd !== null && kanbanSwimlaneValueToAdd !== "null"){
                    this.form[kanbanSwimlaneRowToAdd] = kanbanSwimlaneValueToAdd;

                    setTimeout(() => {
                        localStorage.removeItem('kanban-sub-group-by');
                        localStorage.removeItem('kanban-row');
                    }, 2000);
                }

            });
        },

        fetchSalesBehaviors() {
            let self = this;
            axios.get(route('project.sales-behaviors')).then(({data}) => {
                self.form.sales_behaviors = data.data;
            });
        },

        saved() {

            // if(this.isValidateRequiredField.isRequired || this.isValidateRequiredField.isContractAmountRequired){
            //     return false;
            // }

            if(this.isValidateRequiredField.isContractAmountRequired){
                return false;
            }

            // if(this.foundationContactSyncAccess) {
            //     const salesStatus = this.getSalesStatus(this.form.sales_status_id);
            //     if(this.form.company_contacts.length === 0 && salesStatus !== undefined && salesStatus !== null && salesStatus.contract) {
            //         this.getToast(4000).fire({
            //             type: 'error',
            //             title: 'Please add a contact to the project before saving the sales status to Contract'
            //         });
            //         return false;
            //     }
            // }

            // if (this.sageIntacctContactSyncAccess && this.form.sageIntacctContactSelectedContact == null) {
            //     const salesStatus = this.getSalesStatus(this.form.sales_status_id);
            //     if (this.form.company_contacts.length === 0 && salesStatus !== undefined && salesStatus !== null && salesStatus.contract) {
            //         this.getToast(4000).fire({
            //             type: 'error',
            //             title: 'Please add a contact to the project before saving the sales status to Contract'
            //         });
            //         this.foundationLoading = false;
            //         return false;
            //     }
            //     if (this.form.sageIntacctContactSelectedContact == null && salesStatus !== undefined && salesStatus !== null && salesStatus.contract){
            //         this.getToast(4000).fire({
            //             type: 'error',
            //             title: 'Please select a contact to the project before saving the sales status to Contract'
            //         });
            //         this.foundationLoading = false;
            //         return false;
            //     }
            // }

            if(this.foundationContactSyncAccess) {
                this.$refs.CustomFields.validateProjectManagerCustomField('create');
                if(this.$refs.CustomFields.isRequiredProjectManagerCustomField) {
                    this.getToast(4000).fire({
                        type: 'error',
                        title: 'Please select a Foundation Project Manager and try again'
                    });
                    return false;
                }
            }

            // if(this.validateProposalDeliveredSalesBehaviorChecked()) {
            //     return false;
            // }

            this.saveButtonDisabled = true;
            let self = this;
            axios.get(route('project.get-required-fields')).then((data) => {

                if(data.contract || data.new_file || data.pipeline) {

                    this.saveButtonDisabled = false;
                }
            });

            this.form.custom_fields = this.getCustomField();
            this.form.recordDetailCustomFields = this.$refs.ProjectRecordDetailCustomFields.getCustomFieldForm();
            this.form.post(route('api.project.check')).then((response) => {
                if(response.status == 'error'){
                    Swal.fire({
                        title: 'Project Already Exists',
                        text: "Do you want to create a duplicate",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#01B1AF',
                        confirmButtonText: 'Continue creating!'
                    }).then((result) => {
                        if (result.value) {
                            // this.form.post(route('api.project-contacts.check')).then((responseData) => {
                            //     if(responseData.status == 'error'){
                            //         Swal.fire({
                            //             title: 'Project Contact Already Exist',
                            //             text: "Do you want to create a duplicate contact",
                            //             type: 'warning',
                            //             showCancelButton: true,
                            //             confirmButtonColor: '#01B1AF',
                            //             confirmButtonText: 'Continue creating!'
                            //         }).then((result) => {
                            //             if (result.value) {
                            //                 this.savedAfterCheck();
                            //             } else {
                            //                 this.saveButtonDisabled = false;
                            //                 return false;
                            //             }
                            //         });
                            //     }else{
                            if(this.contactToAddressBook){
                                this.checkContactInAddressBook(this.form.contact_email,this.form.contact_cell)
                            }else{
                                this.savedAfterCheck();
                            }
                            //     }
                            // });
                        }else{
                            this.saveButtonDisabled = false;
                            return false;
                        }
                    });
                }else{
                    // this.form.post(route('api.project-contacts.check')).then((responseData) => {
                    //     if(responseData.status == 'error'){
                    //         Swal.fire({
                    //             title: 'Project Contact Already Exist',
                    //             text: "Do you want to create a duplicate contact",
                    //             type: 'warning',
                    //             showCancelButton: true,
                    //             confirmButtonColor: '#01B1AF',
                    //             confirmButtonText: 'Continue creating!'
                    //         }).then((result) => {
                    //             if (result.value) {
                    //                 this.savedAfterCheck();
                    //             } else {
                    //                 this.saveButtonDisabled = false;
                    //                 return false;
                    //             }
                    //         });
                    //     }else{
                    if(this.contactToAddressBook){
                        this.checkContactInAddressBook(this.form.contact_email,this.form.contact_cell)
                    }else{
                        this.savedAfterCheck();
                    }
                    //     }
                    // });
                }
            }).catch((err) => {
                this.saveButtonDisabled = false;
            });
        },

        goBack() {
            if (this.company && !this.contact){
                window.location = route('company.show', {company: this.company.id});
            }else if (this.company && this.contact){
                window.location = route('contact.edit', {company: this.company.id, contact: this.contact.id});
            }else{
                window.location = route('project.index');
            }
        },

        removeDate(item, index) {
            this.$refs[item][0].clearDate();
            this.form.sales_behaviors[index].completed = 0;
            this.form.sales_behaviors[index].completed_at = null;
            // this.validateProposalDeliveredSalesBehavior(this.form.sales_behaviors[index]);
        },
        removeDateTimePicker(index) {
            this.form.sales_behaviors[index].date = null;
            this.form.sales_behaviors[index].completed = 0;
            this.form.sales_behaviors[index].completed_at = null;
            // this.validateProposalDeliveredSalesBehavior(this.form.sales_behaviors[index]);
        },
        removeCompanyContact(email) {
            this.form.company_contacts = this.form.company_contacts.filter(function (addedContact) {
                return addedContact.email !== email;
            });
        },
        addNewContact() {
            this.newContactForm.reset();
            this.selectedTypeContact = null;
            this.selectedUserContact = null;
            if (this.selectedCompany && this.selectedCompany.is_residential){
                this.selectedTypeContact = this.residential_contact_type;
                this.newContactForm.contact_types_id = this.residential_contact_type.id;
            }
            $("#newContactModal").modal("show");
        },

        newContactSaved() {
            let self = this;
            self.newContactForm.post(route('api.contact.store', {company: self.selectedCompany.id})).then((res) => {
                $("#newContactModal").modal("hide");
                self.fetchContacts()
            });
        },


        getContactTypes() {
            let self = this;
            axios.get(route('api.settings.codes.contact-type.index')).then(({data}) => {
                self.all_contact_types = data;
                if(!self.isContactResidentialActive){
                    self.all_contact_types = data.filter(contactType => contactType.is_residential !== 1)
                }
                self.residential_contact_type = _.find(data, ['is_residential', 1]);
                self.contact_type_options = data.filter(x => !x.is_residential);
                self.contact_type_options.push({id: null, code: ""});
                self.all_contact_types.push({id: null, code: ""});
            });
        },

        parseReference() {
            for (let key in this.form) {
                if (
                    [
                        'sales_behaviors',
                        'base_bid',
                        'contract_amount',
                        'estimated_contract_date',
                        'contract_date',
                        'gross_margin_percentage',
                        'labor_hours',
                        'sales_status_id',
                        'bid_date'
                    ].indexOf(key) === -1
                ) {
                    if (this.reference.hasOwnProperty(key)) {
                        this.form[key] = this.reference[key];
                    }

                    if (key.indexOf('contact') !== -1 && key !== 'company_contacts') {
                        this.form[key] = this.reference.contact[key.slice(8)];
                    }

                    if (key.indexOf('_id') !== -1) {
                        this.form[key] = this.reference[key.slice(0, -3)];
                    }
                }
            }
        },

        // openCompanyCreateModal(name) {
        //     this.$refs.CompanyCreateModal.open(name);
        // },

        // async handleNewCompany(company) {
        //     this.selectedCompany = _.find(this.allCompanies, {id: company.id});
        //     this.fetchContacts();
        // },

        goToPage(page) {
            this.page = page;
            this.fetchData();
        },

        fetchData() {
            let params = {
                filter: this.filter,
                page: this.page
            };
            this.loading = true;

            if (this.contacts.length = 0) {
                this.loading = false;
                return;
            }
            axios.get(route('api.contact.getAllCompaniesContacts'),{params})
                .then( (data) => {
                    this.searchContacts     = data.data.data;
                    this.pagination = data;
                    this.loading      = false;
                }).catch(error => {
                this.loading  = false;
            });
        },

        debounceFilter: _.debounce(function (e) {
            if($('#contact_name').val().length == 0){
                this.form.contact_company_id = '';
            }
            this.filter = e.target.value;
            this.goToPage(1)
        }, 700),

        focusOn(){
            document.getElementById("searchContacts_list").style.display = "block";
        },
        focusOut(){
            var contactName = $('#contact_name').val();
            if(contactName == "" || contactName == null || contactName == undefined){
                document.getElementById("searchContacts_list").style.display = "none";
            }
        },
        populateContacts(contact){
            if (this.form.contact_email){
                if (this.contact){
                    if (this.form.contact_email !== this.contact.email){
                        this.removeCompanyContact(this.form.contact_email)
                    }
                }else {
                    this.removeCompanyContact(this.form.contact_email)
                }
            }
            this.form.contact_name = contact.name
            this.form.contact_email = contact.email
            this.form.contact_cell = contact.cell
            this.form.contact_company_id = contact.company.id;
            contact.id = contact.company_contact_id;
            if(!this.$refs.ProjectCompanyInformation.checkContactAlreadyExists(contact.id, contact.company.id)) {
                this.$refs.ProjectCompanyInformation.addContact(contact, true);
            }
            document.getElementById("searchContacts_list").style.display = "none";

        },
        addCompanyContact(){
            if (this.company && this.contact){
                this.selectedCompany = _.find(this.allCompanies, {id: this.company.id});
                this.$refs.ProjectCompanyInformation.addContact(this.contact, true);
                this.populateCompanyContact(this.contact);
            }
        },
        focusOutOnBlur(){
            $("body").click(function(e) {
                if (e.target.id == "searchContacts_list" || $(e.target).parents("#searchContacts_list").length) {
                    // this.populateContacts(contact);
                } else {
                    document.getElementById("searchContacts_list").style.display = "none";
                }
            });
        },
        off(){
            document.getElementById("overlayConfetti").style.display = "none";
            document.getElementById("confettiBox").style.display = "none";
            window.location = (this.company && !this.contact)? route('company.show', {company: this.company.id}) : route('project.edit', {project: this.data.project_id});
        },
        resetValidationErrors(field) {
            if(field) {
                let status = Array();
                // if(field === 'sales_status_id' && (this.validateSalesStatus() == 1)) {
                //     status.push(false);
                // }
                if(field === 'sales_status_id') {
                    status.push(false);
                }
                if(status.includes(false)) {
                    return false;
                }
                if(this.form.errors.errors[field]) {
                    delete this.form.errors.errors[field];
                }
            }
        },

        getCustomField() {
            let customFields = [];
            let customFieldsArray = [];
            customFieldsArray = this.$refs.CustomFields.getCustomFieldForm();
            let customFieldsKeys = [];
            customFieldsKeys = Object.keys(customFieldsArray);

            if(customFieldsKeys.length > 0) {
                let filedsArray = [];
                customFieldsKeys.forEach((key, index) => {
                    filedsArray[key] = customFieldsArray[key];
                });
                let newCustomFiledsArray = [];
                newCustomFiledsArray.push(filedsArray);

                if(newCustomFiledsArray) {
                    customFields = newCustomFiledsArray[0];
                }
            }

            return customFields;
        },
        // validateProposalDeliveredSalesBehavior(item) {
        //     const self = this;
        //     if (item.proposal_delivered === 1 && (item.completed === '1' || item.completed === 1)) {
        //         const salesStatus = this.getSalesStatus(self.form.sales_status_id);
        //         if(salesStatus !== undefined && (salesStatus.pipeline || salesStatus.contract)) {
        //             self.form.errors.clear('sales_status_id');
        //             self.formErrorObj.field = '';
        //             self.formErrorObj.msg = '';
        //             self.isValidateRequiredField.isRequired = false;
        //             return 0;
        //         }
        //         else {
        //             self.isValidateRequiredField.isRequired = true;
        //             self.formErrorObj = {
        //                 field: 'sales_status_id',
        //                 msg: 'Please select the sales status of pipeline or contract'
        //             };
        //             self.form.errors.push(self.formErrorObj);
        //             return 1;
        //         }
        //     }
        //     else {
        //         self.form.errors.clear('sales_status_id');
        //         self.formErrorObj.field = '';
        //         self.formErrorObj.msg = '';
        //         self.isValidateRequiredField.isRequired = false;
        //         return 0;
        //     }
        // },
        // validateSalesStatus() {
        //     const self = this;
        //     let status = 0;
        //     _.each(self.form.sales_behaviors, function(item) {
        //         if(item.proposal_delivered === 1 && (item.completed === '1' || item.completed === 1)) {
        //             status = self.validateProposalDeliveredSalesBehavior(item);
        //         }
        //     });
        //     return status;
        // },
        validateContractAmount() {
            const self = this;
            const salesStatus = this.getSalesStatus(self.form.sales_status_id);
            if(salesStatus !== undefined && salesStatus !== null && salesStatus.contract) {
                if(self.form.contract_amount && self.form.contract_amount !== 0) {
                    self.form.errors.clear('contract_amount');
                    self.isValidateRequiredField.isContractAmountRequired = false;
                    return 0;
                }
                else {
                    self.isValidateRequiredField.isContractAmountRequired = true;
                    let formErrorObj = {
                        field: 'contract_amount',
                        msg: 'Please enter contract amount'
                    };
                    self.form.errors.push(formErrorObj);
                    return 1;
                }
            }
            else {
                self.form.errors.clear('contract_amount');
                self.isValidateRequiredField.isContractAmountRequired = false;
                return 0;
            }
        },
        getSalesStatus(salesStatusId) {
            const self = this;
            return _.find(self.selects.sales_status, function (sale_status) {
                return sale_status.id === salesStatusId;
            });
        },
        // validateProposalDeliveredSalesBehaviorChecked() {
        //     const self = this;
        //     const salesStatus = this.getSalesStatus(self.form.sales_status_id);
        //     let status = 0;
        //     if(salesStatus !== undefined && salesStatus.dead) {
        //         _.each(self.form.sales_behaviors, function(item) {
        //             if(item.proposal_delivered === 1 && (item.completed === '1' || item.completed === 1)) {
        //                 status = 1;
        //                 self.getToast(5000).fire({
        //                     type: 'error',
        //                     title: "Please checked off completed status of proposal delivered sales behavior"
        //                 });
        //             }
        //         });
        //     }
        //     if(status) {
        //         console.log('Proposal Delivered Sales Behavior Checked OFF');
        //     }
        //     return status;
        // },
        ChangeOrder() {
            const itemObject = {
                sales_status: '',
                contract_amount: '',
                contract_date: '',
            };
            this.change_order.push(itemObject)
        },
        deleteOrder(data){
            const finalArray =  this.change_order.splice(data, 1);
            console.log('calll', data, finalArray)
        },
        savedAfterCheck(){
            let self = this;
            this.savingProject = true;
            self.form.customFieldsData = this.$refs.CustomFields.form;
            const salesStatus = this.getSalesStatus(this.form.sales_status_id);

            if(self.foundationContactSyncAccess) {
                self.form.post(route('api.project.check-foundation-job-scenarios')).then((data) => {
                    if(data.pass) {
                        self.finalStoreDataRequest();
                    }
                    else {
                        this.getToast(4000).fire({
                            type: 'error',
                            title: data.message
                        });
                        self.saveButtonDisabled = false;
                        self.savingProject = false;
                    }
                }).catch((error) => {
                    this.getToast(4000).fire({
                        type: 'error',
                        title: 'Some error occurred!'
                    });
                    self.saveButtonDisabled = false;
                    self.savingProject = false;
                });
            }
            else {
                self.finalStoreDataRequest();
            }
        },
        checkContactInAddressBook(email, cell) {
            axios.post(route('api.company.contact.check-email',  {email: email, cell: cell})).then((response) => {
                if(response.data.status === 'success'){
                    $("#addToAddressBookModal").modal("show");
                }else {
                    this.savedAfterCheck();
                }
            }).catch((err) => {
                this.saveButtonDisabled = false;
            });
        },
        remove_validations(){
            if (this.newAddressBookContactForm.existing_company !== null || this.newAddressBookContactForm.new_company !== ''){
                this.customErrors.existing_company = '';
                this.customErrors.new_company = '';
            }
        },
        addContactToAddressBook() {
            this.newAddressBookContactForm.reset();
            this.newAddressBookContactForm.name = this.form.contact_name
            this.newAddressBookContactForm.email = this.form.contact_email
            this.newAddressBookContactForm.cell = this.form.contact_cell
            this.newAddressBookContactForm.existing_company = null
            this.newAddressBookContactForm.new_company = null
            $("#addToAddressBookModal").modal("hide");
            $("#newContactToAddressBookModal").modal("show");
        },
        disableToggle(){
            document.getElementById("new_company").disabled = true;
        },
        removeDisable(){
            document.getElementById("new_company").disabled = false;
        },
        disableExistingCompany(){
            this.is_true = true;
        },
        enableDropdown(){
            let newCompanyText = $('#new_company').val();
            if (newCompanyText === ""){
                this.is_true = false;
            }
        },
        onPaste(){
            this.is_true = true;
        },
        addressBookContactSaved() {
            let self = this;
            self.addressBookContactSavedButton = true;
            self.adding_contact = true;
            self.form.contact_name = self.newAddressBookContactForm.name
            self.form.contact_email = self.newAddressBookContactForm.email
            self.form.contact_cell = self.newAddressBookContactForm.cell
            if ((self.residential_contact_type.id !== self.newAddressBookContactForm.contact_types_id) && (self.newAddressBookContactForm.existing_company === null || self.newAddressBookContactForm.existing_company === "") && (self.newAddressBookContactForm.new_company === null || self.newAddressBookContactForm.new_company.trim() === "")){
                self.customErrors.existing_company = 'You have to choose the Existing Company or New Company!';
                self.customErrors.new_company = 'You have to choose the Existing Company or New Company!';
                self.addressBookContactSavedButton = false;
                self.adding_contact = false;
                return false
            }
            self.saveButtonDisabled = false;
            let data = {
                existing_company: self.newAddressBookContactForm.existing_company ? self.newAddressBookContactForm.existing_company.id : null,
                new_company: self.newAddressBookContactForm.new_company
            }

            self.newAddressBookContactForm.post(route('api.add-contact', {data:data})).then(async (res) => {
                if(res.new_contact) {
                    await this.$refs.ProjectCompanyInformation.addContact(res.new_contact, true);
                    await this.$refs.ProjectCompanyInformation.triggerCompanyContactsWatcher();
                }
                self.addressBookContactSavedButton = false;
                self.adding_contact = false;
                $("#newContactToAddressBookModal").modal("hide");
                self.savedAfterCheck();
            }).catch((error) => {
                self.addressBookContactSavedButton = false;
                self.adding_contact = false;
            });
        },
        saveWithoutContact(){
            this.form.check_contact_in_address_book  = false;
            this.savedAfterCheck();
        },
        projectCustomFieldResponse(data, response) {
            let self = this;
            self.savingProject = false;
            if(this.completedSalesBehaviorsForSegment.length > 0){
                this.completedSalesBehaviorsForSegment.map(item => {
                    window.analytics.track('Behavior Completed', {
                        projectName: this.form.name,
                        timestamp: moment().format('YYYY-MM-DD  h:mm:ss a'),
                        userName: this.user.name,
                        userEmail: this.user.email,
                        team: this.team.name,
                        salesBehavior: item
                    });
                });
            }
            if(response.showMsg && !self.sageIntacctContactSyncAccess) {
                if(response.redirect) {
                    Swal.fire({
                        title: response.msgType.charAt(0).toUpperCase() + response.msgType.slice(1),
                        type: response.msgType,
                        showCancelButton: false,
                        showConfirmButton: false,
                        html: `
                            <p>${response.message}</p>
                            <br>
                            <button type="button" id="routeBtn" class="btn btn-primary ml-2" style="background-color:#01B1AF;">Go to Settings</button>`,
                        onBeforeOpen: () => {
                            const routeBtn = document.querySelector('#routeBtn')
                            routeBtn.addEventListener('click', () => {
                                window.location = response.redirectUrl;
                            });
                        }
                    }).then((result) => {
                        self.showConfettiResponse(data);
                    });
                }
                else {
                    self.getToast(4000).fire({
                        type: response.msgType,
                        title: response.message,
                    });
                    if(self.foundationContactSyncAccess && !response.foundationJobNo && response.hasOwnProperty('foundationMessage') && response.foundationMessage !== '') {
                        if (self.form.sales_status_id){
                            const salesContractStatus = self.getSalesStatus(self.form.sales_status_id);
                            if (salesContractStatus.contract === 1){
                                self.getToast(4000).fire({
                                    type: 'error',
                                    title: response.foundationMessage,
                                });
                            }
                        }
                        self.showConfettiResponse(data);
                    }
                    else {
                        self.showConfettiResponse(data);
                    }
                }
            }
            else {
                this.getToast(4000).fire({
                    type: 'success',
                    title: data.message,
                });
                self.showConfettiResponse(data);
            }
        },
        validateContactWithContractSaleStatus(saleStatusId, oldSaleStatusId) {
            let self = this;
            let salesStatus = self.getSalesStatus(saleStatusId);
            if(salesStatus !== null && salesStatus !== undefined && salesStatus.contract === 1) {
                if(self.form.company_contacts.length === 0) {
                    self.form.sales_status_id = oldSaleStatusId;
                    // self.validateContractAmount();
                    this.getToast(4000).fire({
                        type: 'error',
                        title: 'Please add a contact to the project before changing the status to Contract'
                    });
                }
            }
        },
        showConfettiResponse(data) {
            let self = this;

            if (data.confetti.length > 0 && data.notificationExist == 0) {
                setTimeout(() => {
                    document.getElementById("overlayConfetti").style.display = "block";
                    document.getElementById("confettiBox").style.display = "block";
                }, 2000);
                axios.post(route('api.project.update-celebration-key', {project_id: data.project_id}));
            }
            if (data.confetti.length == 0) {
                window.location = (self.company && !self.contact) ? route('company.show', {company: self.company.id}) : route('project.edit', {project: data.project_id});
            }
        },
        finalStoreDataRequest() {
            this.savingProject = true;
            this.form.userTimeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            this.form.userTimeZoneOffset = new Date().getTimezoneOffset();
            this.form.recordDetailCustomFieldForm = this.$refs.ProjectRecordDetailCustomFields.form;
            this.form.post(route('api.project.store')).then((data) => {
                this.data = data;
                this.$refs.CustomFields.submit(data.project_id, data, 'create');
                window.analytics.track('File Created', {
                    projectName: this.form.name,
                    timestamp: moment().format('YYYY-MM-DD  h:mm:ss a'),
                    userName: this.user.name,
                    userEmail: this.user.email,
                    team: this.team.name
                });
            }).catch((err) => {
                this.saveButtonDisabled = false;
                this.savingProject = false;
            });
        },



        fetchContactCustomFields() {
            let self = this;
            let params = `?contact=true`;
            axios.get(route('api.contact-custom-field.index') + params).then(({data}) => {
                self.contact_custom_fields = data.data;
            });
        },
        fetchCompanyCustomFields() {
            let self = this;
            let params = `?company=true`;
            axios.get(route('api.company-custom-field.index')  + params).then(({data}) => {
                self.company_custom_fields = data.data;
            });
        },
        validateFoundationCustomerNumber() {
            let self = this;
            if(self.externalFoundationCustomFieldValue && self.externalFoundationCustomFieldValue.length > 10) {
                self.externalFoundationCustomFieldValue = self.externalFoundationCustomFieldValue.slice(0, 10);
                self.getToast(2000).fire({
                    type: 'error',
                    title: 'Customer ID cannot exceed 10 characters'
                });
            }
        },
        closePushContactToFoundationModal() {
            this.externalFoundationCustomFieldValue = null;
            $('.push-to-foundation-loader-' + this.selectedContactForPushFoundation.id).hide();
        },
        updateAddedContactsAfterFoundationPush(addedContactIds) {
            let self = this;
            axios.post(route('api.contact.get-details'), {contactIds: JSON.stringify(addedContactIds)}).then(({data}) => {
                _.forEach(addedContactIds, function(contactId) {
                    let contactData = _.find(data.data, {id: contactId});
                    self.form.company_contacts = self.form.company_contacts.map(item => {
                        if(item.id === contactId) {
                            item.foundation_customer_no = contactData.foundation_customer_no;
                            item.sage_intacct_customer_no = contactData.sage_intacct_customer_no;
                            item.sage_intacct_record_no = contactData.sage_intacct_record_no;
                            item.contact_synced_to_sage_intacct = contactData.contact_synced_to_sage_intacct;
                        }
                        return item;
                    });
                });
            });
        },
        checkIsSalesActivityCompleted(item){
            if(item.completed === '1'){
                this.completedSalesBehaviorsForSegment.push(item.name);
                if(item.complete_comment){
                    this.tempSalesActivity = item;
                    $('#projectSaleBehaviorCompleteCommentModal').modal('show');
                }
            }else {
                if(this.completedSalesBehaviorsForSegment.length > 0){
                    this.completedSalesBehaviorsForSegment = this.completedSalesBehaviorsForSegment.filter(x => x !== item.name)
                }
            }
        },
        initAutocompleteContact() {
            let input = document.getElementById('searchTextFieldContact');
            autocompleteContact = new google.maps.places.Autocomplete(input, {
                componentRestrictions: {
                    country: ['us','ca']
                }
            });

            google.maps.event.addListener(autocompleteContact, 'place_changed', this.getAddressComponentsContact);
        },

        getAddressComponentsContact() {
            let placeResultData = autocompleteContact.getPlace();
            this.newAddressBookContactForm.lat = placeResultData.geometry.location.lat();
            this.newAddressBookContactForm.lng = placeResultData.geometry.location.lng();
            this.newAddressBookContactForm.zip = '';
            this.newAddressBookContactForm.city = '';
            this.newAddressBookContactForm.state = '';
            placeResultData.address_components.map(res=>{
                if(res.types[0]==='postal_code'){
                    this.newAddressBookContactForm.zip = res.short_name;
                }
                if(res.types[0]==='locality'){
                    this.newAddressBookContactForm.city = res.short_name;
                }
                if(res.types[0]==='administrative_area_level_1'){
                    this.newAddressBookContactForm.state = res.short_name;
                }
            });
            this.newAddressBookContactForm.address = placeResultData.name;
        },
        projectSalesActivityCommentSaved() {
            this.form_changed = false;
            window.onbeforeunload = null;
            let self = this;
            self.form.saving = true;
            self.form.post(route('api.project-comment.store', {project: self.project.id})).then((res) => {
                this.form_changed = false;
                self.form.saving = false;
                self.checkCommentStatus = 1;
                self.saved(true);
                $("#projectCommentModal").modal("hide");
                $("#projectSaleBehaviorCompleteCommentModal").modal("hide");
                self.tempSalesActivity = null;
                window.analytics.track('Project Comments', {
                    projectName: self.form.name,
                    timestamp: moment().format('YYYY-MM-DD  h:mm:ss a'),
                    userName: self.user.name,
                    userEmail: self.user.email,
                    comment: self.form.comment,
                    team: self.team.name
                });
                //load Notes comments
            });
        },
        addMention(){

        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.vdatetime-popup{

    height: 500px !important;
}

</style>
<style lang="scss">
.vdp-datepicker {
    &.fullscreen-when-on-mobile {
        @media (max-width: 767px) {
            position: static;
            .vdp-datepicker__calendar {
                position: fixed;
                top: 50%;
                left: 5%;
                margin-top: -25%;
                width: 90%;
                z-index: 2000;
                outline: rgba(0, 0, 0, 0.5) solid 9999px;
            }
        }
    }
}

.sales-behavior-checkbox {
    width: 1.3rem;
    height: 1.3rem;
}

.cell {
    &.today {
        background-color: rgb(220, 245, 252);
    }
}
.contactDiv:hover {
    background-color: #e3e3e3;
}

#overlayConfetti {
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top:18px;
    left: 0;
    right: 0;
    bottom: 0;
    //background-color: rgba(0,0,0,0.5);
    z-index: 999;
    cursor: pointer;
    margin-top: 56px;
}
.required-field-color {
    border: 1px solid #e3342f;
}
.pac-container {
    z-index: 1055 !important;
}
</style>
